module.exports = __webpack_public_path__ + "static/media/bg-yellow.a17f19fe.svg";